module.exports = __webpack_public_path__ + "img/ear.9681a433.svg";